import { PageHeader as AntPageHeader, PageHeaderProps as AntPageHeaderProps } from 'antd';
import pageHeaderStyles from './page-header.module.css';
interface PageHeaderProps extends AntPageHeaderProps {}

const PageHeader: React.FC<PageHeaderProps> = (props) => {
    return <AntPageHeader className={pageHeaderStyles.pageHeader} {...props} />;
};

export default PageHeader;
